import { Component } from '@opten/compiler/metadata/component';

declare const Cookiebot: any;

@Component({ className: 'js-window-print', observe: true })
export class WindowPrintComponent {
  constructor(private element: HTMLElement) {
    this.element.addEventListener('click', (e) => {
      e.preventDefault();
      window.print();
    });
  }
}
